import { render, staticRenderFns } from "./LichSuDichVuAmThucForm.vue?vue&type=template&id=a0dfb954&scoped=true"
import script from "./LichSuDichVuAmThucForm.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuAmThucForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuAmThucForm.vue?vue&type=style&index=0&id=a0dfb954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dfb954",
  null
  
)

export default component.exports